import { AuthUtils } from '../../../core/auth/auth.utils';

export const shortcuts = [
    {
        id: 'a1ae91d3-e2cb-459b-9be9-a184694f548z',
        label: 'Core',
        name: 'core',
        translate: 'SHORTCUTS.CORE',
        description: '',
        icon: 'heroicons_outline:circle-stack',
        link: '/core/dashboard',
        module: AuthUtils.MODULE_CORE,
        useRouter: true,
    },
    {
        id: 'a1ae91d3-e2cb-459b-9be9-a184694f548h',
        label: 'Order & Quote Management',
        name: 'omng',
        translate: 'SHORTCUTS.ORDERS_&_QUOTES',
        description: '',
        icon: 'feather:list',
        link: '/omng/dashboard',
        module: AuthUtils.MODULE_QUOTE_ORDER_MANAGEMENT,
        useRouter: true,
    },
    {
        id: 'a1ae91d3-e2cb-459b-9be9-a184694f548c',
        label: 'Management',
        name: 'mng',
        translate: 'SHORTCUTS.MANAGEMENT',
        description: '',
        icon: 'feather:tool',
        link: '/mng/dashboard',
        module: AuthUtils.MODULE_MANAGEMENT,
        useRouter: true,
    },
    {
        id: 'l9AHxkGAp0MYqQ%YPsOEqy!$',
        label: 'HR',
        name: 'hr',
        translate: 'SHORTCUTS.HR_LEAVE_MANAGEMENT',
        description: '',
        icon: 'mat_outline:emoji_people',
        link: '/hr/dashboard',
        module: AuthUtils.MODULE_HR_LEAVE_MANAGEMENT,
        useRouter: true,
    }
];
